"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeExponeaNotification = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const checkExponea = (successCallback) => {
    let exponeaRetries = 3;
    const exponeaPixel = window.exponea;
    if (typeof exponeaPixel !== 'undefined') {
        successCallback();
    }
    else {
        if (exponeaRetries !== 0) {
            window.setTimeout(() => {
                exponeaRetries -= 1;
                checkExponea(successCallback);
            }, 200);
        }
    }
};
const subscribe = () => {
    window.exponea.notifications.isAvailable((available) => {
        if (available) {
            console.log('Browser supports push notifications!');
            window.exponea.notifications.isSubscribed((active, _denied) => {
                if (active) {
                    console.log('The user is already subscribed');
                    // the user is already subscribed
                    // } else if (denied) {
                    // the user has already interacted with the prompt and declined
                }
                else {
                    window.exponea.notifications.subscribe((status) => {
                        if (status === 'subscribed') {
                            console.log('The user has been subscribed to push notifications');
                            window.exponea.track('consent', {
                                action: 'accept',
                                category: 'banner',
                                valid_until: 'unlimited',
                                location: window.location.pathname,
                                browser: window.navigator.userAgent,
                            });
                        }
                        else {
                            console.warn('Failed to subscribe the user to push notifications:', status);
                        }
                    }, { push_notifications: true });
                }
            });
        }
        else {
            console.warn('Browser does NOT support push notifications.');
        }
    });
};
const subscribeExponeaNotification = (user) => {
    checkExponea(() => {
        var _a, _b;
        const yandex_metrika = js_cookie_1.default.get('_ym_uid');
        const google_analytics = (_b = (_a = js_cookie_1.default.get('_ga')) === null || _a === void 0 ? void 0 : _a.match(/GA.\..\.(.*)/)) === null || _b === void 0 ? void 0 : _b[1];
        window.exponea.identify(Object.assign(Object.assign(Object.assign({}, (user && { registered: user === null || user === void 0 ? void 0 : user.sub })), (yandex_metrika && { yandex_metrika })), (google_analytics && { google_analytics })));
        setTimeout(() => {
            subscribe();
        }, 5000);
    });
};
exports.subscribeExponeaNotification = subscribeExponeaNotification;
